import { IListPromotionItem } from '@/features/coupon/types'
import dayjs from 'dayjs'

const isUnavailableVoucher = (item: IListPromotionItem) => {
  // Kiểm tra voucher hết hạn hoặc không khả dụng
  const now = dayjs()
 
  // hết hạn
  let isExpired = dayjs(item?.from_date).isAfter(now, 'day')
   if(item?.to_date){
    isExpired = dayjs(item?.to_date).isBefore(now, 'day')
  }
  // không hợp lệ
  const isUnValidAutoApplyVoucher = item?.code == null && !item?.is_applied
  // không được active hoặc hết hạn hoặc không hợp lệ
  const isUnavailable = !item?.is_active || isExpired || isUnValidAutoApplyVoucher
  return isUnavailable
}

const isTheAutoAppliedVoucher = (item: IListPromotionItem) => {
  // Kiểm tra voucher tự động áp dụng
  return item?.is_applied && item?.code == null
}

const isUnavailableVoucherWithMessage = (item: IListPromotionItem) => {
  // Kiểm tra voucher hết hạn hoặc không khả dụng
  const now = dayjs()
 
  // hết hạn
  let isExpired = dayjs(item?.from_date).isAfter(now, 'day')
   if(item?.to_date){
    isExpired = dayjs(item?.to_date).isBefore(now, 'day')
  }
  if(isExpired){
    return {
      isUnavailable: true,
      message: null
    }
  }
  // không hợp lệ
  const isUnValidAutoApplyVoucher = item?.code == null && !item?.is_applied
  // không được active hoặc hết hạn hoặc không hợp lệ
  const isUnavailable = !item?.is_active || isUnValidAutoApplyVoucher
  return {
      isUnavailable: true,
      message: ''
    }
}

export { isUnavailableVoucher, isTheAutoAppliedVoucher, isUnavailableVoucherWithMessage }